export const lazyLoad = (loader) => {

    const state = {
        isLoading: false,
        promise: null,
    };

    const load = () => {
        state.isLoading = true;

        return state.promise = loader()
            .catch(e => {
                state.promise = null;
                throw e;
            })
            .finally(() => state.isLoading = false);
    };

    const get = () => state.promise || load();

    const map = mapper => lazyLoad(() => get().then(mapper));

    return {
        isLoading: () => state.isLoading,
        get,
        map,
    };
};



// WEBPACK FOOTER //
// ./src/portal/lib/lazy-load.js